'use client'

import HeaderRightSearchLayerCategory from '@dg/common/components/Mobile/Header/HeaderView/HeaderRightSearchLayer/HeaderRightSearchLayerView/HeaderRightSearchLayerCategory/HeaderRightSearchLayerCategory'

export default HeaderRightSearchLayerCategory
